const pendingByTimeEntry = new Map<string, Promise<unknown>>();

export const registerTrackingProjectUpdate = (
  timeEntryId: string,
  promise: Promise<unknown>,
): void => {
  pendingByTimeEntry.set(timeEntryId, promise);
  void promise.finally(() => {
    if (pendingByTimeEntry.get(timeEntryId) === promise) {
      pendingByTimeEntry.delete(timeEntryId);
    }
  });
};

export const awaitPendingTrackingProjectUpdate = (
  timeEntryId: string,
): Promise<unknown> => pendingByTimeEntry.get(timeEntryId) ?? Promise.resolve();
